/**
 * Grilles « aperçu / distribution » (listes sous Options avancées, .employees-container).
 * Densité colonnes mobile : src/core/styles/erp-global-mobile-ui.css via [data-erp-overview-n].
 *
 * @param {number} segmentCount — nombre de segments (ex. distributionInfo.data.length)
 * @param {'3' | '4'} mdCols — colonnes grille à partir du breakpoint md
 * @param {string} [extraGridClasses] — classes Tailwind supplémentaires (ex. lg:grid-cols-4)
 */
export function getErpOverviewGridAttrs(segmentCount, mdCols = '4', extraGridClasses = '') {
  const md =
    mdCols === '3'
      ? 'md:grid-cols-3'
      : mdCols === '4'
        ? 'md:grid-cols-4'
        : `md:grid-cols-${mdCols}`;
  const extra =
    typeof extraGridClasses === 'string' && extraGridClasses.trim()
      ? ` ${extraGridClasses.trim()}`
      : '';
  return {
    'data-erp-overview-n': String(segmentCount),
    className: `grid gap-4 grid-cols-1 sm:grid-cols-2 ${md}${extra}`
      .replace(/\s+/g, ' ')
      .trim(),
  };
}
